import { NavLink } from "react-router-dom";
import { useTranslation } from "../../../i18n/TranslationProvider";
import { useAuth } from "../../../contexts/AuthContext";

const AdminNavBar = () => {
    const { t } = useTranslation();
    const {userProfile} = useAuth(); 

    const navItems =
        userProfile?.iiss_type === "emr"
            ? [
                  { to: "/emr-dashboard", label: t("nav.emrAssessment") },
                  { to: "/licenses", label: t("nav.assignLicenses") },
              ]
            : [
                  { to: "/athletes", label: t("nav.athleteRoster") },
                  { to: "/licenses", label: t("nav.assignLicenses") },
              ];

    const tabClasses = ({ isActive }) =>
        `px-6 py-3 text-sm md:text-base font-semibold border border-b-0 rounded-t-lg transition-colors ${
            isActive
                ? "bg-white border-gray-200  text-cyan-700 relative z-10 shadow-top"
                : "bg-gray-100 border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-cyan-700"
        }`;

    return (
        <nav className="flex mx-auto w-4/5 md:w-2/3 lg:w-1/2 -mb-px">
            {navItems.map((item) => (
                <NavLink key={item.to} to={item.to} end className={tabClasses}>
                    {item.label}
                </NavLink>
            ))}
        </nav>
    );
};

export default AdminNavBar;